module.exports = __webpack_public_path__ + "static/power-of-reviews-jaredd-craig-ab7617d9cb946ea80fed2b9b7e00a9b1.jpg";